/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type AdVehicleStreamEvaluateCabinSafetyCheckStatusFragment = {
  __typename?: 'FccWaypoint'
  id: string
  adState: Types.FccWaypointState | null
  actions: Array<
    | { __typename: 'FccWaypointDeliveryAction' }
    | { __typename: 'FccWaypointHubReturnAction' }
    | { __typename: 'FccWaypointPickupAction' }
    | { __typename: 'FccWaypointReallocationAction' }
  >
}

export const AdVehicleStreamEvaluateCabinSafetyCheckStatusFragmentDoc = gql`
    fragment AdVehicleStreamEvaluateCabinSafetyCheckStatus on FccWaypoint {
  id
  adState
  actions {
    __typename
  }
}
    `
